import React, { useState } from 'react';
import './OrganizationTree.css';

/**
 * OrganizationTreeNode - ツリーの各ノードを表示するコンポーネント
 */
function OrganizationTreeNode({ 
  node, 
  onAdd, 
  onEdit, 
  onDelete,
  isRoot = false 
}) {
  const [isExpanded, setIsExpanded] = useState(true);
  const hasChildren = node.children && node.children.length > 0;

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="tree-node">
      <div className={`tree-node-content ${isRoot ? 'tree-node-root' : ''}`}>
        {hasChildren && (
          <button 
            className="tree-toggle" 
            onClick={handleToggle}
            aria-label={isExpanded ? '閉じる' : '開く'}
          >
            {isExpanded ? '▼' : '▶'}
          </button>
        )}
        {!hasChildren && <span className="tree-spacer"></span>}
        
        <span className="tree-node-name">
          {node.organization_unit_name || node.name}
          {node.organization_unit_code && (
            <span className="tree-node-code"> ({node.organization_unit_code})</span>
          )}
        </span>

        <div className="tree-node-actions">
          <button 
            className="btn btn-sm btn-primary tree-action-btn" 
            onClick={() => onAdd(node)}
            title="子組織を追加"
          >
            + 追加
          </button>
          {!isRoot && (
            <>
              <button 
                className="btn btn-sm btn-secondary tree-action-btn" 
                onClick={() => onEdit(node)}
                title="編集"
              >
                編集
              </button>
              <button 
                className="btn btn-sm btn-danger tree-action-btn" 
                onClick={() => onDelete(node)}
                title="削除"
              >
                削除
              </button>
            </>
          )}
        </div>
      </div>

      {hasChildren && isExpanded && (
        <div className="tree-children">
          {node.children.map(child => (
            <OrganizationTreeNode
              key={child.organization_unit_id}
              node={child}
              onAdd={onAdd}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          ))}
        </div>
      )}
    </div>
  );
}

/**
 * OrganizationTree - 組織階層をツリー表示するコンポーネント
 */
export default function OrganizationTree({ 
  company,
  organizationUnits, 
  onAdd, 
  onEdit, 
  onDelete 
}) {
  // ルートノードを作成（会社名）
  const rootNode = {
    organization_unit_id: null,
    name: company.company_name,
    children: organizationUnits
  };

  if (!company) {
    return (
      <div className="organization-tree-empty">
        会社を選択してください
      </div>
    );
  }

  return (
    <div className="organization-tree">
      <OrganizationTreeNode
        node={rootNode}
        onAdd={onAdd}
        onEdit={onEdit}
        onDelete={onDelete}
        isRoot={true}
      />
      
      {organizationUnits.length === 0 && (
        <div className="organization-tree-empty">
          組織がまだ登録されていません。「+ 追加」ボタンから組織を追加してください。
        </div>
      )}
    </div>
  );
}
